export default __webpack_public_path__ + "static/media/services6.695f0cd4.jpg";